// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e7e6aa6","982":"582310a8"}[chunkId] + ".chunk.js";
};